export const EMPLOYEE_STATUSES = {
  ENGAGED: 'engaged',
  LEAVING: 'leaving',
  JOINING: 'joining',
  REMOVED: 'removed'
};

export const getStatusColor = (status) => {
  switch (status) {
    case EMPLOYEE_STATUSES.ENGAGED:
      return '#DCFCE7';
    case EMPLOYEE_STATUSES.JOINING:
      return '#FEF9C3';
    case EMPLOYEE_STATUSES.LEAVING:
      return '#FEE2E2';
    case EMPLOYEE_STATUSES.REMOVED:
      // should be some kind of gray color
      return '#F1F5F9';
    default:
      return '#E5E7EB';
  }
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case EMPLOYEE_STATUSES.ENGAGED:
      return '#166534';
    case EMPLOYEE_STATUSES.JOINING:
      return '#854D0E';
    case EMPLOYEE_STATUSES.LEAVING:
      return '#991B1B';
    case EMPLOYEE_STATUSES.REMOVED:
      return '#64748B';
    default:
      return '#374151';
  }
}; 

export const getStatusText = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
}; 